/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";

export function Phone() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Phone:</label>
      <span>{appointment.booking?.phone}</span>
    </div>
  );
}
